/**
 * Rollback mechanism for the spatial visual consolidation.
 *
 *   • Set `REACT_APP_ENABLE_SPATIAL_VISUAL_SYSTEM=false` at build time to
 *     disable the `body.mf-spatial` scoping (global CSS reverts to legacy
 *     brand-colored rules). Token-driven sx changes are not gated by this
 *     flag because they replace brand tokens with neutrals — reverting
 *     them is a git revert of the PR, not a runtime toggle.
 *
 *   • `isSpatialRoute(pathname)` identifies routes where the floor plan is
 *     the primary content surface. Editor + gallery + admin viewers all
 *     qualify; auth, dashboard, analytics, and admin CRUD do not.
 */
export const ENABLE_SPATIAL_VISUAL_SYSTEM =
  process.env.REACT_APP_ENABLE_SPATIAL_VISUAL_SYSTEM !== "false";

const SPATIAL_ROUTE_PREFIXES = [
  "/upload-floor",
  "/layout/",
  "/gallery/",
  "/floor-gallery/",
  "/floor-plan/",
  "/admin/upload-floor",
  "/admin/layout/",
  "/admin/gallery/",
  "/admin/floor-gallery/",
  "/admin/floor-plan/",
];

export function isSpatialRoute(pathname = "") {
  const path = String(pathname || "");
  return SPATIAL_ROUTE_PREFIXES.some((prefix) => {
    const trimmed = prefix.replace(/\/$/, "");
    return path === trimmed || path.startsWith(prefix);
  });
}

export function shouldApplySpatialVisualSystem(pathname = "") {
  return ENABLE_SPATIAL_VISUAL_SYSTEM && isSpatialRoute(pathname);
}

export const SPATIAL_BODY_CLASS = "mf-spatial";
